import { Branch } from '../base/branch';
import { Folder, Genus } from './genus';
import { Content } from './content';
import { Site } from './site';
import { Prototype } from '../tree/prototype';
import { Aspect } from './aspect';
import { Node } from '../base/node'

export class NodeInfo {

    constructor(private readonly node: Node) {
    }

    get branch(): Branch | undefined {
        return this.node instanceof Branch ? this.node : undefined;
    }

    get genus(): Genus | undefined {
        return this.node instanceof Genus ? this.node : undefined;
    }

    get folder(): Folder | undefined {
        return this.node instanceof Folder ? this.node : undefined;
    }

    get content(): Content | undefined {
        return this.node instanceof Content ? this.node : undefined;
    }

    get site(): Site | undefined {
        return this.node instanceof Site ? this.node : undefined;
    }

    get prototype(): Prototype | undefined {
        return this.node instanceof Prototype ? this.node : undefined;
    }

    get aspect(): Aspect | undefined {
        return this.node instanceof Aspect ? this.node : undefined;
    }
}
